import React from 'react';

import { BIO_STATES, BIO_NAMES } from '@/components/onboarding/Shared';
import { type bioPageProps } from '@/types/globals';

import PreferencePage from './PreferencePage';

const placeholder = `In your own words, tell us about your communications preferences. Here’s an example from Mat, our founder:

    •   I’m an email guy. I commit to reading every email from someone I know within 1 working day. Even if I haven’t responded, I’ve read your email.
    •   If it’s urgent, send me a text.
    •   I love Slack for collaborating. If you think I can help, @ me. I’ll always prefer a huddle.
    •   Do not ever leave me a voicemail. They get deleted. If you get my voicemail and need to find me right now, text me.
    •   If you’re a colleague, feel free to swing by. Call ahead in case I’m OOO.`;

function CommunicationPreferencesPanel({
    isModal = false,
    extendContinue = null,
    overrideBack = null,
    isEdit,
    openBrief,
}: bioPageProps) {
    return (
        <PreferencePage
            fieldName="communicationPreferences"
            header="Let others know how you prefer to communicate."
            subHeader="In your own words, tell us how you like to communicate with colleagues, contacts and strangers. Not sure what we're asking? We've shared an example below."
            subHeaderWidth="max-w-[600px]"
            inputLabelText="What are your communication preferences?"
            inputPlaceholder={placeholder}
            bioStep={3}
            totalSteps={5}
            stepNames={BIO_NAMES}
            bioState={BIO_STATES.communicationPreferences}
            isModal={isModal}
            isEdit={isEdit}
            extendContinue={extendContinue}
            overrideBack={overrideBack}
            openBrief={openBrief}
        />
    );
}

export default CommunicationPreferencesPanel;
